import * as orderApi from '@api/order'
import { createEffect, createStore } from 'effector'
import { useStore } from 'effector-react'
import { IGoodBasket } from '@entities/basket/contract'
import { subscribeLoggerEffect } from 'src/infastruct/effector-utils/subscribe-sentry'
import { sumBy } from 'lodash-es'

/**
 * Treshhold model
 */
export interface Threshold {
    minFreeDeliverySum: number
    deliveryCost: number
}

export interface Sums {
    sumStock: number
    sumDelivery: number
    sumDeliveryFull: number
    sumMin: number
    deliveryCost: number
}

export interface ThresholdSums {
    threshold: Threshold
    sums: Sums
}

const initialTreshhold: Record<number, Threshold> = {}

/**
 * threshold effect
 */
export const geThresholdFx = createEffect<
    {
        basketItems: IGoodBasket[]
    },
    ThresholdSums,
    Error
>({
    handler: async ({ basketItems }) => {
        const threshold: Threshold = await orderApi.getThreshold()
        if (!threshold || !threshold.deliveryCost) throw new Error('Не удалось получить данные о стоимости доставки')
        const basketItemsByPrescriptionDelivery = basketItems.filter(
            (x) => x.isAvailableDeliveryByErecipe && !x.deliveryStatus?.isAvailableForDelivery
        )
        const sumStock = sumBy(basketItems, (item) => item.stockPriceSum)
        const sumDelivery =
            sumBy(basketItems, (item) => item.deliveryPriceSum) +
            sumBy(basketItemsByPrescriptionDelivery, (item) => (item.deliveryPrice?.normal || 0) * item.count)
        const sumMin = sumBy(basketItems, (item) => item.minPriceSum)
        const isNotFreeDelivery = sumDelivery <= threshold.minFreeDeliverySum
        const sumDeliveryFull = isNotFreeDelivery ? sumDelivery + threshold.deliveryCost : sumDelivery
        const deliveryCost = isNotFreeDelivery ? threshold.deliveryCost : 0

        return {
            threshold,
            sums: {
                sumStock,
                sumDelivery,
                sumDeliveryFull,
                sumMin,
                deliveryCost
            } as Sums
        } as ThresholdSums
    }
})

subscribeLoggerEffect(geThresholdFx)

/**
 * treshhold store
 */
export const $thresholdStore = createStore<ThresholdSums>(initialTreshhold as unknown as ThresholdSums, {
    serialize: 'ignore'
}).on(geThresholdFx.doneData, (_, values) => values)
export const useThreshold = () => useStore($thresholdStore)
